import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { TableContext } from '../../../components/Table/TableContext';
import { IndicateEmploymentStatusDataType } from '../../../models/dashboard/driver-list/indicate-employment-status';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useIndicateEmploymentStatus = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const tableContext = useContext(TableContext);


  const onIndicateEmploymentStatusError = (
    err: AxiosError<ErrorHttpResponse>,
  ) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while indicating employment status.',
    );
  };

  const onIndicateEmploymentStatusSuccess = (callback: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Employment status indicated successfully.');
    callback();
    tableContext?.setRefreshTable(!tableContext?.refreshTable);
  };

  const indicateEmploymentStatus = (data: IndicateEmploymentStatusDataType, driverId: string, callback: () => void) => {
    const formData = new FormData();
    formData.append('employmentType', data.employmentType);

    const url: HttpConfig = {
      url: `api/v1/dispatchers/${driverId}/update-info`,
      method: 'patch',
      data: formData,
    };
    request(
      url,
      onIndicateEmploymentStatusSuccess(callback),
      setLoading,
      onIndicateEmploymentStatusError,
    );
  };

  return { indicateEmploymentStatus, loading };
};

export default useIndicateEmploymentStatus;
